import { render, staticRenderFns } from "./CircleLoader.vue?vue&type=template&id=59aa0335&scoped=true&"
var script = {}
import style0 from "./CircleLoader.vue?vue&type=style&index=0&id=59aa0335&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59aa0335",
  null
  
)

export default component.exports